import classNames from 'classnames';
import React from 'react';

interface LabelProps {
  name: string;
  title: string;
  required?: boolean;
}

const Label: React.FC<LabelProps> = ({ name, title, required }) => (
  <label
    className={classNames('text-[10px] uppercase text-black', {
      "after:content-['_*'] after:text-red-500": required,
    })}
    htmlFor={name}
  >
    {title}
  </label>
);

export default Label;
